<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">报警数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>

      <div class="modal-body">

        <div>
          <div style="float: right;padding-right: 10px;">

            <el-date-picker size="mini" style="margin-right: 10px;width:220px;" title="起止时间"
                            v-model="startEndTime" :clearable="false"
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            range-separator="至"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间">
            </el-date-picker>

            <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>

          </div>
          <div style="clear: both"></div>
        </div>

        <div style="height: 10px;"></div>

        <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="400" border>

          <el-table-column prop="deviceName" label="设备名称" ></el-table-column>
          <el-table-column prop="address" label="位置"></el-table-column>
          <el-table-column prop="createTime" :formatter="timefilter" label="报警时间"></el-table-column>

        </el-table>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="20"
                           :current-page.sync="currentPage"  @current-change="current_change">
            </el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>


import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";


export default {
  name: "WangGuanData",
  data() {
    return {
      tableLoading:false,
      dataInfoShow:false,

      roomCode: '',


      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      startEndTime:[],

      type:14,

    }
  },
  components: {

  },

  methods: {
    init(roomCode) {
      this.roomCode = roomCode;
      //this.type='';

      const end = new Date();
      const start = new Date(end - 1000 * 60 * 60 * 24 * 360);
      this.startEndTime = [start, end];

      this.getList();

    },

    closeSelf() {
      this.$emit("closePushData");
    },



    timefilter(row,index,column){
      return timefilters(column)
    },


    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "AlarmRecord/PageByRoomCodeType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          roomCode: this.roomCode,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          startTime: timefilters(this.startEndTime[0]),
          endTime: timefilters(this.startEndTime[1]),
          type:this.type,
        }
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error === 0) {
          this.tableData=response.data.data.list;
          this.totalItems=response.data.data.total;
        } else if (response.data.error === 1) {
          this.$message.error(response.data.message)
        }
      })

    },




  }


}
</script>

<style lang="scss" scoped>

</style>
